import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../FormComponents/Input";
import { useHttp } from "../../hooks/useHttp";
import { showSuccess, showError } from "../../util/toast";
import { API_URLS, DEFAULT_HEADERS } from "../../util/constants";
import { handleApiError } from "../../util/errorHandler";
import { Toaster } from "react-hot-toast";
import { createContactSchema } from "../../util/validation";
import { sanitizeString } from "../../util/sanitize";

const contactFormSchema = createContactSchema();

const ContactForm = () => {
  const { sendRequest } = useHttp();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(contactFormSchema),
  });

  const onSubmit = async (data) => {
    try {
      // Sanitiza os dados antes de enviar
      const sanitizedData = {
        name: sanitizeString(data.companyName),
        email: sanitizeString(data.companyEmail),
        phone: sanitizeString(data.companyPhone),
        desiredProduct: sanitizeString(data.desiredProduct || ""),
        message: sanitizeString(data.message || ""),
      };

      const responseData = await sendRequest(
        API_URLS.MAIN_CONTACT,
        "POST",
        JSON.stringify(sanitizedData),
        DEFAULT_HEADERS.JSON
      );
      if (responseData.success) {
        showSuccess(responseData.message);
        reset();
      } else {
        showError(responseData.message);
      }
    } catch (error) {
      handleApiError(error, { context: "ContactForm.onSubmit" });
    }
  };

  return (
    <div id="contact" className="ltn__contact-message-area mb-60">
      <Toaster />
      <div className="container">
        <div className="row">
          <div className="col-lg-12 m-auto">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="ltn__form-box contact-form-box box-shadow white-bg p-4">
                <h4 className="title-2 form-text-home">
                  Nos mande uma mensagem
                </h4>
                <h1 className="form-text-home">
                  Quer mais informações? Mande um e-mail!
                </h1>
                <div className="row">
                  <div className="col-md-6">
                    <Input
                      register={register}
                      className="input-item input-item-name ltn__custom-icon mb-15"
                      type="text"
                      fieldName="companyName"
                      placeholder="Insira seu nome ou o de sua empresa*"
                      errors={errors}
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      className="input-item input-item-email ltn__custom-icon mb-15"
                      register={register}
                      type="email"
                      fieldName="companyEmail"
                      placeholder="Insira seu melhor e-mail *"
                      errors={errors}
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      register={register}
                      type="text"
                      className="input-item input-item-arrow ltn__custom-icon mb-15"
                      fieldName="desiredProduct"
                      placeholder="Qual tipo de produto você está à procura? *"
                      errors={errors}
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      className="input-item input-item-phone ltn__custom-icon mb-15"
                      register={register}
                      type="text"
                      fieldName="companyPhone"
                      placeholder="Insira seu telefone ou o de sua empresa *"
                      errors={errors}
                    />
                  </div>
                  <div className="col">
                    <Input
                      className="input-item input-item-textarea ltn__custom-icon mb-15"
                      textarea
                      register={register}
                      fieldName="message"
                      type="text"
                      placeholder="Insira aqui sua mensagem."
                      errors={errors}
                    />
                  </div>
                </div>
                <div className="btn-wrapper mt-0">
                  <button
                    className="btn theme-btn-1 btn-effect-1 text-uppercase"
                    type="submit"
                    disabled={isSubmitting}
                    title="Mandar mensagem agora!"
                  >
                    Mandar mensagem agora!
                  </button>
                </div>
              </div>
              <p className="form-messege mb-0 mt-20" />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContactForm;
